export default "__VITE_ASSET__DrErC0eP__"